import { render } from "./OrganizationForm.vue?vue&type=template&id=4b1876c4&ts=true"
import script from "./OrganizationForm.vue?vue&type=script&lang=ts"
export * from "./OrganizationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__